export function Picture() {
  return (
    <path
      fill="currentColor"
      d="M6.545 0h34.91C45.07 0 48 2.93 48 6.545v34.91C48 45.07 45.07 48 41.455 48H6.545C2.93 48 0 45.07 0 41.455V6.545C0 2.93 2.93 0 6.545 0zM19.2 26.4l-9.6 12h28.8l-7.2-9.6-4.872 6.504L19.2 26.4zM36 15.6c0-1.992-1.608-3.6-3.6-3.6s-3.6 1.608-3.6 3.6 1.608 3.6 3.6 3.6 3.6-1.608 3.6-3.6z"
    />
  )
}
